"use client";

import { useEffect } from "react";
import { useLocaleStore, detectBrowserLocale } from "@/store/locale.store";

/**
 * Picks up the browser language on first load (until the user picks one explicitly)
 * and keeps the <html lang> attribute in sync with the active locale.
 */
export function LocaleApplier() {
  const locale = useLocaleStore((s) => s.locale);

  // Auto-detect once on mount, only if the user hasn't chosen a language yet.
  // Done in an effect (not at render) to avoid SSR/client hydration mismatches.
  useEffect(() => {
    const { hasUserSetLocale, initLocale } = useLocaleStore.getState();
    if (!hasUserSetLocale) initLocale(detectBrowserLocale());
  }, []);

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  return null;
}
